<!-- 发现阶段占比 -->
<template>
  <div>
    <a-card size="small" class="chart-card">
      <template slot="title">
        <span style="margin-right: 4px">发现阶段占比</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间：创建时间</p>
            <p>计算方式: 自然日计算</p>
            <p>统计维度: 状态为DONE的非生产缺陷</p>
            <p>描述：所选时间段内各团队或各团队成员基于缺陷发现阶段的分布占比情况</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div id="issue-stage" :style="{ height: height, width: width }" />
    </a-card>
    <a-modal :visible="modalVisible" :footer="null" :title="title" :closable="false" :width="900" @cancel="closeModal">
      <a-table :columns="columns" :data-source="tableData" :width="800">
        <span slot="issueTitle" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
        <span slot="issueStage" slot-scope="text, record">
          {{ issueStages[record.stage].label }}
        </span>
        <span slot="issueSerious" slot-scope="text, record">
          {{ issueSerious[record.serious].label }}
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { issueStages, issueSerious } from '@/utils/dictionary';

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      issueStages,
      issueSerious,
      myChart: null,
      modalVisible: false,
      title: '',
      tableData: [],
      issueData: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '缺陷标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'issueTitle' },
          width: 450
        },
        {
          title: '发现阶段',
          dataIndex: 'stage',
          scopedSlots: { customRender: 'issueStage' },
          width: 120
        },
        {
          title: '等级',
          dataIndex: 'serious',
          scopedSlots: { customRender: 'issueSerious' },
          sorter: (a, b) => {
            if (a.serious !== b.serious) {
              return a.serious - b.serious;
            } else {
              return a.handler.localeCompare(b.handler);
            }
          }
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'handler',
          scopedSlots: { customRender: 'handler' },
          sorter: (a, b) => {
            if (a.handler !== b.handler) {
              return a.handler.localeCompare(b.handler);
            } else {
              return a.serious - b.serious;
            }
          }
        }
      ],
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center',
          show: false
        },
        series: [
          {
            name: '缺陷总数',
            type: 'pie',
            radius: '60%',
            center: ['50%', '50%'],
            data: [],
            label: {
              formatter: '{b} ({d}%)',
              fontSize: 12
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    link() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          query: { issueId: record.id },
          params: { project_id: record.project_id }
        });
        return route.href;
      };
    }
  },
  watch: {
    data() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('issue-stage'));
    this.myChart.on('click', params => {
      this.tableData = this.issueData[params.dataIndex];
      this.modalVisible = true;
      this.title = params.data.name + '(' + this.issueData[params.dataIndex].length + '个' + ')';
    });
    setTimeout(() => {
      this.getDiagramData();
    }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    closeModal() {
      this.modalVisible = false;
    },
    getDiagramData() {
      this.option.series[0].data = []; // 清空原有数据
      this.issueData = []; // 清空issueData数组
      const stage_list = ['ci', 'ui', 'nvwa', 'qa', 'demo', 'prod', 'qa(prod_done)', 'dev_try'];
      stage_list.forEach(key => {
        if (this.data.items && Array.isArray(this.data.items)) {
          this.data.items.forEach(el => {
            if (el.issues_stage[key] && el.issues_stage[key].length > 0) {
              this.option.series[0].data.push(
                {
                  value: el.issues_stage[key].length,
                  name: '[' + issueStages[el.issues_stage[key][0]['stage']]['label'] + ']' + el.team_name
                }
              );
              this.issueData.push(el.issues_stage[key]);
            }
          }
          );
        }
      });
      this.drawChart();
    }
  }
};
</script>

<style>
.chart-card {
  justify-content: center;
  align-items: center;
}
</style>
